import globalComponents from './globalComponents'
import globalDirectives from './globalDirectives'
import VueSweetalert2 from 'vue-sweetalert2'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VTooltip from 'v-tooltip'
import VueGoodTablePlugin from 'vue-good-table';
import SSOPlugin from './ssoPlugin'

import { HttpClient } from '../lib/HttpClient'
import { Text } from '../lib/Helper'
import {CryptoAWS} from '../lib/Crypto';

import '../assets/styles/sweetalert2.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  install (Vue, options = {}) {
    Vue.use(BootstrapVue)
    Vue.use(VueSweetalert2)
    Vue.use(globalComponents)
    Vue.use(globalDirectives)
    Vue.use(Vuelidate)
    Vue.use(VTooltip)
    Vue.use(VueGoodTablePlugin);
    Vue.use(SSOPlugin, { store: options.store })
    Vue.prototype.$httpClient = HttpClient
    Vue.prototype.$httpClientExterno = HttpClient;
    Vue.prototype.$text = Text
    Vue.prototype.$crypto = CryptoAWS
  }
}
